
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAuto as ObiAutoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-auto.js';
 
 
 

 
 export const ObiAuto = createComponent({
   react: React,
   tagName: 'obi-auto',
   elementClass: ObiAutoElement,
   events: {
     
   }
  });
 
 